import { Component, input } from '@angular/core';
import {
  QaiAccordionItemDirective,
  QaiAccordionHeaderDirective,
  QaiAccordionToggleDirective,
  QaiAccordionBodyDirective,
  QaiIconComponent,
} from '@qai/ui';
import { IAccordionCardIcon } from 'src/app/interfaces/iaccordion-card-icon';

@Component({
  selector: 'app-accordion-card',
  standalone: true,
  templateUrl: './accordion-card.component.html',
  styleUrls: ['./accordion-card.component.scss'],
  imports: [
    QaiAccordionItemDirective,
    QaiAccordionHeaderDirective,
    QaiAccordionToggleDirective,
    QaiAccordionBodyDirective,
    QaiIconComponent,
  ],
})
export class AccordionCardComponent {
  title = input.required<string>();
  subHeading = input<string>();
  icon = input<IAccordionCardIcon>();
  expanded = input(false);
}
